module.exports = __webpack_public_path__ + "media/images/gallery/constellations/coma_berenices/com_vis-a67d86e303829dd9590262c632a56442.jpg";